export const getNextPageFromUrl = (nextUrl: string | null) => {
  if (nextUrl) {
    const nextPage = new URLSearchParams(nextUrl).get('page');
    return nextPage ? parseInt(nextPage, 10) : undefined;
  }

  return undefined;
};
